<template>
    <div>
        <span
            v-html="$t('notification.reservationCreated',{ name: $_.get(activity,'payload.userName'), visitor:$_.get(activity,'payload.visitorFullname'), date: $_.get(activity, 'payload.date')})"></span>
    </div>
</template>
<script>
export default {
    name: "ReservationCreated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
<style></style>
